import { RasterBoolCatComponentProperties } from "../components/raster_bool_cat_component"

export const FAOSTATProperties: RasterBoolCatComponentProperties = {
    name: 'FAOSTAT Suitability Classiciation',
    sources: [

        {name: '1km Irrigated Wetland Rice', source: 'ind:faostat_wetrice_irrigated_cls'},
        {name: '1km Irrigated Dryland Rice', source: 'ind:faostat_dryrice_irrigated_cls'},
        {name: '1km Irrigated Maize', source: 'ind:faostat_mze_irrigated_cls'},
        {name: '1km Irrigated Oil Palm', source: 'ind:faostat_olp_irrigated_cls'},

        {name: '1km Rainfed Wetland Rice', source: 'ind:faostat_wetrice_rainfed_cls'},
        {name: '1km Rainfed Dryland Rice', source: 'ind:faostat_dryrice_rainfed_cls'},
        {name: '1km Rainfed Maize', source: 'ind:faostat_mze_rainfed_cls'},
        {name: '1km Rainfed Oil Palm', source: 'ind:faostat_olp_rainfed_cls'},

        {name: '10km Irrigated Wetland Rice', source: 'ind:faostat_01_20_wetrice_irrigated_cls'},
        {name: '10km Irrigated Dryland Rice', source: 'ind:faostat_01_20_dryrice_irrigated_cls'},
        {name: '10km Irrigated Maize', source: 'ind:faostat_01_20_mze_irrigated_cls'},
        {name: '10km Irrigated Oil Palm', source: 'ind:faostat_01_20_olp_irrigated_cls'},

        {name: '10km Rainfed Wetland Rice', source: 'ind:faostat_01_20_wetrice_rainfed_cls'},
        {name: '10km Rainfed Dryland Rice', source: 'ind:faostat_01_20_dryrice_rainfed_cls'},
        {name: '10km Rainfed Maize', source: 'ind:faostat_01_20_mze_rainfed_cls'},
        {name: '10km Rainfed Oil Palm', source: 'ind:faostat_01_20_olp_rainfed_cls'},

        {name: '10km Irrigated Wetland Rice 1981-2000', source: 'ind:faostat_81_00_wetrice_irrigated_cls'},
        {name: '10km Irrigated Dryland Rice 1981-2000', source: 'ind:faostat_81_00_dryrice_irrigated_cls'},
        {name: '10km Irrigated Maize 1981-2000', source: 'ind:faostat_81_00_mze_irrigated_cls'},
        {name: '10km Irrigated Oil Palm 1981-2000', source: 'ind:faostat_81_00_olp_irrigated_cls'},

        {name: '10km Rainfed Wetland Rice 1981-2000', source: 'ind:faostat_81_00_wetrice_rainfed_cls'},
        {name: '10km Rainfed Dryland Rice 1981-2000', source: 'ind:faostat_81_00_dryrice_rainfed_cls'},
        {name: '10km Rainfed Maize 1981-2000', source: 'ind:faostat_81_00_mze_rainfed_cls'},
        {name: '10km Rainfed Oil Palm 1981-2000', source: 'ind:faostat_81_00_olp_rainfed_cls'},
    ],
    sourceType: 'Data',
    combineSources: false,
    options: [
        {label: 'no data', value: 0},
        {label: 'SI >85: Very high', value: 1},
        {label: 'SI >70 & <85: High', value: 2},
        {label: 'SI >55 & <70: Good', value: 3},
        {label: 'SI >40 & <55: Medium', value: 4},
        {label: 'SI >25 & <40: Moderate', value: 5},
        {label: 'SI >10 & <25: Marginal', value: 6},
        {label: 'SI >0 & <10: Very marginal', value: 7},
        {label: 'SI <0: Unsuitable', value: 8},
        {label: 'No cropland', value: 9},
        {label: 'Water', value: 10},
    ]
}